export enum OrderSliderForms {
  ACCESSINFO = 'AccessInfo',
  SERVICES = 'Services'
}

export enum AccessType {
  KEYPAD = 'Keypad',
  LOCKBOX = 'Lockbox',
  RENTLY = 'Rently'
}
